import ipark from './ipark'
import AppService from './AppService'
import groundPark from './ground-parking';


export default {
    ipark,
    AppService,
    groundPark
}


// WEBPACK FOOTER //
// ./src/api/index.js